import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import ProgressBar from "react-bootstrap/ProgressBar";
import config from "../../config/config";
import "./css/tokenslide.css"

export default function Banner() {
  const [tokenSold, setTokenSold] = useState(0);
  const [presaleInfiBalance, setPresaleInfiBalance] = useState(0);
  const now = 60;

  return (
    <>
      <section className="hero-banner" style={{ minHeight: "600px" }}>
        <Container className="pt-5">
          <Row className="">
            <Col lg={6} className="mb-4">
              <div className="banner_content position-relative start-0 end-0">
                <h1 className="">
                  Create, Launch & Trade
                  <div>
                    <span className="fw-normal">
                      Your Project on{" "}
                      <span className="text-primary">INFI Launchpad</span>
                    </span>
                  </div>
                </h1>
                <p className="fs-6">
                  <strong>Introducing the Next Generation INFI Launchpad — Powered by the ©SbSe Protocol.</strong>
                  <p></p>
                  Step into the future of decentralized innovation with the <strong>INFI Launchpad</strong>, a next-generation
                  platform governed by the advanced <strong>©SbSe Protocol</strong>. Purpose-built for community growth and
                  Web3 empowerment, INFI supports seamless deployment across <strong>13+ live blockchains</strong> through
                  full <strong>multi-chain integration.</strong>
                  <p></p>
                  Whether you're launching a new token or scaling an existing project, INFI offers <strong>zero-cost token
                  listings, no-fee fundraising opportunities</strong>, and <strong>completely free AMM (Automated MarketMaker) services — with no monthly fees.</strong> 
                  Our <strong>automated, decentralized infrastructure</strong> ensures <strong>liquidity protection</strong>, transparent governance, and <strong>a safe trading environment for everyone</strong> —
                  from crypto newcomers to seasoned developers.
                </p>
              </div>
              <div className="btn-bg mt-5 position-relative">
                <div className="position-relative z-1">
                  <div className="mb-2">
                    <Button
                      variant="custombtn"
                      className="text-uppercase text-black fw-bold px-5 rounded-5 btn-register w-100"
                      onClick={() => window.location.href = `${config.baseUrl}promos`}
                    >
                      PAID PROMOTIONS&nbsp;&nbsp;
                      <svg
                        style={{ marginTop: "-3px" }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="16"
                        viewBox="0 0 24 19"
                        fill="none"
                      >
                        <path
                          d="M15.9223 1.39307L22.803 9.52486M22.803 9.52486L15.9223 17.6566M22.803 9.52486L1.45706 9.52485"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Button>
                    {/* <Button
                        variant="primary"
                        className="text-uppercase  text-black fw-bold px-4 rounded-5 btn-register"
                      >
                        Buy Token Now
                      </Button> */}
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={1}></Col>
            <Col
              lg={5}
              className={`cardStyle position-relative z-2 position-relative`}
            >
              <div className="cardBox2 mb-3 overflow-hidden rainbow rounded-0">
                <div className="p-4 tokenBox">
                  <Swiper
                    className="mySwiper"
                    spaceBetween={30}
                  >
                    <SwiperSlide>
                      <div>
                        <div>
                          <span className="text-primary x-small">
                            Fundraise Goal
                          </span>
                        </div>
                        <h3 className="text-black fw-bold my-2">$300,000</h3>
                        <p>Maximum funding goal reached</p>
                      </div>
                      <div className="mb-3">
                        <ProgressBar
                          // now={(tokenSold / presaleInfiBalance) * 100}
                          now={`100%`}
                          label={`${now}%`}
                          visuallyHidden
                        />
                      </div>
                      <div className="mb-3">
                        <div className="">
                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Allocation</span>
                            <b className="fs-5">$350 - $0</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Price Per token</span>
                            <b className="fs-5">$0.521</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">ATH ROI</span>
                            <b className="fs-5">TBA</b>
                          </div>
                        </div>
                      </div>
                      <Button variant="dark" className="w-100">
                        Buy AXVERSE
                      </Button>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div>
                        <div>
                          <span className="text-primary x-small">
                            Fundraise Goal
                          </span>
                        </div>
                        <h3 className="text-black fw-bold my-2">$400,000</h3>
                        <p>Maximum funding goal reached</p>
                      </div>
                      <div className="mb-3">
                        <ProgressBar
                          // now={(tokenSold / presaleInfiBalance) * 100}
                          now={`100%`}
                          label={`${now}%`}
                          visuallyHidden
                        />
                      </div>
                      <div className="mb-3">
                        <div className="">
                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Allocation</span>
                            <b className="fs-5">$350 - $0</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Price Per token</span>
                            <b className="fs-5">$0.521</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">ATH ROI</span>
                            <b className="fs-5">TBA</b>
                          </div>
                        </div>
                      </div>
                      <Button variant="dark" className="w-100">
                        Buy AXVERSE
                      </Button>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div>
                        <div>
                          <span className="text-primary x-small">
                            Fundraise Goal3
                          </span>
                        </div>
                        <h3 className="text-black fw-bold my-2">$500,000</h3>
                        <p>Maximum funding goal reached</p>
                      </div>
                      <div className="mb-3">
                        <ProgressBar
                          // now={(tokenSold / presaleInfiBalance) * 100}
                          now={`100%`}
                          label={`${now}%`}
                          visuallyHidden
                        />
                      </div>
                      <div className="mb-3">
                        <div className="">
                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Allocation</span>
                            <b className="fs-5">$350 - $0</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Price Per token</span>
                            <b className="fs-5">$0.521</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">ATH ROI</span>
                            <b className="fs-5">TBA</b>
                          </div>
                        </div>
                      </div>
                      <Button variant="dark" className="w-100">
                        Buy AXVERSE
                      </Button>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div>
                        <div>
                          <span className="text-primary x-small">
                            Fundraise Goal4
                          </span>
                        </div>
                        <h3 className="text-black fw-bold my-2">$600,000</h3>
                        <p>Maximum funding goal reached</p>
                      </div>
                      <div className="mb-3">
                        <ProgressBar
                          // now={(tokenSold / presaleInfiBalance) * 100}
                          now={`100%`}
                          label={`${now}%`}
                          visuallyHidden
                        />
                      </div>
                      <div className="mb-3">
                        <div className="">
                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Allocation</span>
                            <b className="fs-5">$350 - $0</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Price Per token</span>
                            <b className="fs-5">$0.521</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">ATH ROI</span>
                            <b className="fs-5">TBA</b>
                          </div>
                        </div>
                      </div>
                      <Button variant="dark" className="w-100">
                        Buy AXVERSE
                      </Button>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div>
                        <div>
                          <span className="text-primary x-small">
                            Fundraise Goal5
                          </span>
                        </div>
                        <h3 className="text-black fw-bold my-2">$700,000</h3>
                        <p>Maximum funding goal reached</p>
                      </div>
                      <div className="mb-3">
                        <ProgressBar
                          // now={(tokenSold / presaleInfiBalance) * 100}
                          now={`100%`}
                          label={`${now}%`}
                          visuallyHidden
                        />
                      </div>
                      <div className="mb-3">
                        <div className="">
                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Allocation</span>
                            <b className="fs-5">$350 - $0</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">Price Per token</span>
                            <b className="fs-5">$0.521</b>
                          </div>

                          <div className="d-flex justify-content-between mb-2">
                            <span className=" text-grey fs-5">ATH ROI</span>
                            <b className="fs-5">TBA</b>
                          </div>
                        </div>
                      </div>
                      <Button variant="dark" className="w-100">
                        Buy AXVERSE
                      </Button>
                    </SwiperSlide>
                  </Swiper>

                </div>
              </div>

              {/* <div className="social-icon socialBox mb-0 text-black ">
                    <ul className="mb-0 py-3">
                      <li>
                        <a href="#">
                          <img
                            src="assets/images/ico/icon/bitcoin.png"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img
                            src="assets/images/ico/icon/litecoin.png"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img
                            src="assets/images/ico/icon/chainlink.png"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img
                            src="assets/images/ico/icon/siacoins.png"
                            alt=""
                          />
                        </a>
                      </li>
                    </ul>
                  </div> */}

              <div className="threecoin">
                <img src="images/threecoin.png" alt="" width={`100%`} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
